(() => {
  'use strict';
  const store = window.AkaariWishlist;
  const dialog = document.getElementById('akaari-native-wishlist');
  if (!store || !dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const body = dialog.querySelector('[data-nw-body]');
  const note = dialog.querySelector('#nw-note');
  const status = document.querySelector('[data-nw-status]');
  const root = (dialog.dataset.root || '/').replace(/\/?$/, '/');
  let opener = null;
  let toastTimer;
  let controller;
  let generation = 0;
  const cache = new Map();
  const productUrl = item => root + 'products/' + encodeURIComponent(item.handle) + (item.variantId ? '?variant=' + item.variantId : '');
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function announce(message) {
    clearTimeout(toastTimer);
    status.textContent = message;
    if (dialog.open) dialog.querySelector('[data-nw-feedback]').textContent = message;
    status.classList.add('is-visible');
    toastTimer = setTimeout(() => { status.classList.remove('is-visible'); }, 3500);
  }
  const setAttribute = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
  function sync() {
    const list = store.get();
    const saved = new Set(list.map(item => item.handle));
    document.querySelectorAll('[data-nw-toggle]').forEach(button => {
      const active = saved.has(button.dataset.nwHandle);
      setAttribute(button, 'aria-pressed', String(active));
      setAttribute(button, 'aria-label', `${active ? 'Remove' : 'Save'} ${button.dataset.nwName || 'product'} ${active ? 'from' : 'to'} wishlist`);
      const label = button.querySelector('[data-nw-label]');
      if (label) { const text = active ? 'Saved to wishlist' : 'Save to wishlist'; if (label.textContent !== text) label.textContent = text; }
    });
    document.querySelectorAll('[data-nw-count]').forEach(count => { if (count.textContent !== String(list.length)) count.textContent = String(list.length); if (count.hidden !== !list.length) count.hidden = !list.length; });
    document.querySelectorAll('[data-nw-open]').forEach(button => setAttribute(button, 'aria-label', `Open wishlist, ${list.length} saved ${list.length === 1 ? 'item' : 'items'}`));
    dialog.querySelector('[data-nw-title-count]').textContent = list.length ? `(${list.length})` : '';
    note.textContent = store.isPersistent() ? 'Saved in this browser. View a piece to check its latest details and choose your options.' : 'Browser storage is unavailable. These saves last only until this page is closed or reloaded.';
  }
  async function getProduct(handle, signal) {
    const hit = cache.get(handle);
    if (hit && Date.now() - hit.time < 60000) return hit.data;
    const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { signal, credentials: 'same-origin' });
    if (!response.ok) { const error = new Error('Product unavailable'); error.unavailable = response.status === 404; throw error; }
    const data = await response.json();
    if (!Array.isArray(data.variants)) throw new Error('Invalid product details');
    cache.set(handle, { time: Date.now(), data });
    return data;
  }
  function safeImage(source) {
    if (typeof source !== 'string' || !source) return null;
    try {
      const url = new URL(source, window.location.origin);
      if (url.protocol !== 'https:') return null;
      // Only use images returned by Shopify, never HTML from saved browser data.
      url.searchParams.set('width', '240');
      return url.href;
    } catch (_) { return null; }
  }
  async function draw() {
    const currentGeneration = ++generation;
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const list = store.get();
    const oldButtons = [...body.querySelectorAll('[data-nw-remove]')];
    const focusIndex = oldButtons.indexOf(document.activeElement);
    body.replaceChildren();
    if (!list.length) {
      const empty = element('div', 'nw-empty');
      empty.append(element('h3', '', 'Keep your favourites close'), element('p', '', 'Tap the heart on any piece to save it here.'));
      body.append(empty);
      if (focusIndex >= 0) dialog.querySelector('.nw-footer a').focus();
      return;
    }
    const rows = list.map(item => {
      const row = element('article', 'nw-item');
      const imageLink = element('a', 'nw-image-link'); imageLink.href = productUrl(item); imageLink.setAttribute('aria-label', item.name);
      const info = element('div', 'nw-info');
      const title = element('a', 'nw-item-title', item.name); title.href = productUrl(item);
      const variant = element('p', 'nw-variant');
      const price = element('p', 'nw-price', 'Loading details…');
      const view = element('a', 'nw-view', 'View product'); view.href = productUrl(item);
      const remove = element('button', 'nw-remove', 'Remove'); remove.type = 'button'; remove.dataset.nwRemove = item.handle; remove.setAttribute('aria-label', `Remove ${item.name} from wishlist`);
      const actions = element('div', 'nw-item-actions'); actions.append(view, remove);
      info.append(title, variant, price, actions); row.append(imageLink, info); body.append(row);
      return { item, row, imageLink, title, variant, price, view, remove };
    });
    if (focusIndex >= 0) rows[Math.min(focusIndex, rows.length - 1)].remove.focus({ preventScroll: true });
    let next = 0;
    const worker = async () => {
      while (next < rows.length && !signal.aborted) {
        const row = rows[next++];
        try {
          const data = await getProduct(row.item.handle, signal);
          if (signal.aborted || currentGeneration !== generation) return;
          const selected = row.item.variantId ? data.variants.find(v => String(v.id) === row.item.variantId) : null;
          const variant = selected || data.variants.find(v => v.available) || data.variants[0];
          row.title.textContent = data.title || row.item.name;
          row.variant.textContent = selected ? (selected.title === 'Default Title' ? '' : selected.title) : (row.item.variantId ? 'Saved option changed — choose an option' : 'Choose your options on the product page');
          if (row.item.variantId && !selected) {
            const url = root + 'products/' + encodeURIComponent(row.item.handle);
            row.title.href = row.imageLink.href = row.view.href = url;
          }
          const amount = selected?.price ?? data.price_min ?? data.price;
          if (typeof amount === 'number') {
            const price = new Intl.NumberFormat(dialog.dataset.locale || 'en-IN', { style: 'currency', currency: dialog.dataset.currency || 'INR' }).format(amount / 100);
            row.price.textContent = (!selected && data.price_varies ? 'From ' : '') + price;
          } else row.price.textContent = 'View product for current price';
          if ((selected && !selected.available) || (!selected && !data.available)) row.variant.textContent += (row.variant.textContent ? ' · ' : '') + 'Currently sold out';
          const source = safeImage(variant?.featured_image?.src || data.featured_image);
          if (source) {
            const img = element('img'); img.src = source; img.alt = data.title || row.item.name; img.loading = 'lazy'; img.decoding = 'async'; img.width = 104; img.height = 104; row.imageLink.append(img);
          }
        } catch (error) {
          if (signal.aborted) return;
          row.price.textContent = error.unavailable ? 'This product is no longer available' : 'Details unavailable — try opening the product';
          if (error.unavailable) { row.view.hidden = true; row.title.removeAttribute('href'); row.imageLink.removeAttribute('href'); }
        }
      }
    };
    await Promise.all([worker(), worker(), worker()]);
  }
  function open(button) {
    if (dialog.open) return;
    opener = button;
    sync();
    dialog.querySelector('[data-nw-feedback]').textContent = '';
    dialog.showModal();
    document.documentElement.classList.add('nw-lock');
    draw();
  }
  dialog.addEventListener('close', () => {
    controller?.abort();
    document.documentElement.classList.remove('nw-lock');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-nw-toggle], [data-nw-open], [data-nw-close], [data-nw-remove]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    if (button.hasAttribute('data-nw-open')) { open(button); return; }
    if (button.hasAttribute('data-nw-close')) { dialog.close(); return; }
    if (button.hasAttribute('data-nw-remove')) { store.remove(button.dataset.nwRemove); announce('Removed from wishlist'); return; }
    const handle = button.dataset.nwHandle;
    if (store.has(handle)) { store.remove(handle); announce('Removed from wishlist'); return; }
    // Prefer the current product form or card URL after a variant change.
    let variantId = button.dataset.nwVariant;
    if (button.dataset.nwPlacement === 'product') {
      const input = button.closest('.buy-buttons-block')?.querySelector('input[name="id"]');
      if (input?.value) variantId = input.value;
    } else {
      const link = button.closest('product-card')?.querySelector('a[ref="productCardLink"]');
      if (link?.href) variantId = new URL(link.href).searchParams.get('variant') || variantId;
    }
    const result = store.add({ handle, name: button.dataset.nwName, variantId });
    announce(!result.ok ? 'Your wishlist is full. Remove a piece to save another.' : result.persistent ? 'Saved to your wishlist' : 'Saved for this page only — browser storage is unavailable');
  }, true);
  document.addEventListener('akaari:wishlist-change', () => { sync(); if (dialog.open) draw(); });
  document.addEventListener('variant:update', () => requestAnimationFrame(sync));
  // Refresh only newly inserted wishlist controls after filters/quick-add/section renders.
  let scheduled = false;
  new MutationObserver(records => {
    const changed = records.some(record => (record.type === 'attributes' && record.target.matches('[data-nw-toggle], [data-nw-open], [data-nw-count]')) || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-nw-toggle], [data-nw-open]') || node.querySelector('[data-nw-toggle], [data-nw-open]'))));
    if (!changed || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-label', 'hidden', 'data-nw-handle'] });
  window.addEventListener('pageshow', sync);
  sync();
})();
